"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeValuableItemsForRemovalWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualHomeValuableItemsForRemovalWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeValuableItemsForRemovalWidget, _super);
    function AnnualHomeValuableItemsForRemovalWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnualHomeValuableItemsForRemovalWidget.prototype.render = function () {
        var items = this.props.interaction.valuableItems ? this.props.interaction.valuableItems : [];
        var bicycles = this.props.interaction.bicycles ? this.props.interaction.bicycles : [];
        var filteredOutSpecifiedItems = __spreadArray(__spreadArray([], items, true), bicycles, true).filter(function (item) { return !item.flowValuable; })
            .filter(function (item) { return item.coverLocation === services_1.ValuableItemCoverLocation.HOME; });
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: filteredOutSpecifiedItems.length > 0 &&
                (0, jsx_runtime_1.jsx)("div", { className: "removed-item-info-panel font-weight-extra-light quote row banner banner-info margin-x-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "p-0 d-flex col removed-valuable-item align-items-start", children: [(0, jsx_runtime_1.jsx)("div", { className: "removed-item-info-icon selected flex-start" }), (0, jsx_runtime_1.jsx)("div", { children: this.renderWording(filteredOutSpecifiedItems) })] }) }) }));
    };
    AnnualHomeValuableItemsForRemovalWidget.prototype.renderWording = function (filteredOutSpecifiedItems) {
        var aggregator = (0, commonFunctions_1.getAggregatorDisplayName)(this.props.interaction.source);
        var dynamicProductList = this.prepareDynamicProductListString(filteredOutSpecifiedItems);
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["We have removed ", (0, jsx_runtime_1.jsx)("b", { children: dynamicProductList }), " you have listed on ", aggregator, ' ', "as they do not fall within our definition of a valuable or a personal belonging. Don't worry, these will be covered within your contents sum insured. Please check the level of cover meets your needs."] }));
    };
    AnnualHomeValuableItemsForRemovalWidget.prototype.prepareDynamicProductListString = function (items) {
        var itemDescriptions = items.map(function (item) { return item.description; });
        var itemCount = items.length;
        var descriptions;
        if (itemDescriptions.length === 1) {
            descriptions = itemDescriptions[0];
        }
        else {
            var lastItemDescription = itemDescriptions.pop();
            descriptions = "".concat(itemDescriptions.join(', '), " and ").concat(lastItemDescription);
        }
        return "".concat(itemCount, " specified item").concat(itemCount > 1 ? "s" : "", " (").concat(descriptions, ")");
    };
    return AnnualHomeValuableItemsForRemovalWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeValuableItemsForRemovalWidget = AnnualHomeValuableItemsForRemovalWidget;
//# sourceMappingURL=AnnualHomeValuableItemsForRemovalWidget.js.map